import React, { Component } from "react"
import "./FakeStats.scss"
import Flip from "./Flip/Flip";
import ScrollableAnchor from "react-scrollable-anchor/";

class FakeStats extends Component {
    render() {
        return (
            <ScrollableAnchor id="stats">
                <section className="section section-fakestats">
                    <div className="padding">
                        <div className="container">
                            <div className="headline">
                                <div className="head">
                                    השוואות סטטיסטיות בין הכל להכל
                            </div>
                                <div className="separator"></div>
                            </div>
                            <Flip />
                        </div>
                    </div>
                </section>
            </ScrollableAnchor>
        )
    }
}

export default FakeStats;


// WEBPACK FOOTER //
// ./src/Components/FakeStats/FakeStats.jsx